import './App.scss';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import routes from './router';
import React from 'react';
import Alerts from './components/alerts/Alerts';

class App extends React.Component<{}, { isMobileMenuOpened: boolean }> {

  constructor(props: any) {
    super(props);
    this.state = { isMobileMenuOpened: false };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState(prevState => ({
      isMobileMenuOpened: !prevState.isMobileMenuOpened
    }));
  }

  render() {


    return this.renderApp()
  }

  renderApp() {
    return (
      <React.Fragment>
        <Router>
          <div className="h-full bg-gray-900" style={{minHeight:'100vh'}}>
            <div className="min-h-full">
              <Alerts></Alerts>
              <Routes>
                {
                  routes.map((it) => {
                    return (
                      <Route key={it.path} path={it.path} element={it.component} />
                    )
                  })
                }
              </Routes>
            </div>
          </div>
        </Router>
      </React.Fragment>

    );
  }
}

export default App;

